/**
 *
 * @param {String} input
 */
const replaceFnCommas = (input) => {
  return input.replace(/\((.*?)\)/, (string) => {
    return string.replace(/,/g, "|");
  });
}

export default replaceFnCommas;